module.exports = __webpack_public_path__ + "img/selectPayTypeBtn.aa41b38f.png";